import { call } from 'redux-saga/effects';
import * as Sentry from '@sentry/react';
import { downloadChatImageRequested } from 'features/chat/actions';
import { notification } from 'features/notifications/toast/notification';
import i18n from 'i18n';
import { downloadFile } from 'utils/http/downloadFile';

export function* downloadChatImageSaga(action: ReturnType<typeof downloadChatImageRequested>) {
  try {
    const { url, fileName } = action.payload;

    const response: Response = yield call(fetch, url);
    const blob: Blob = yield call([response, 'blob']);

    yield call(downloadFile, blob, null, {
      fileName: fileName ?? 'chat-image',
      mimeType: blob.type,
    });
  } catch (error) {
    Sentry.captureException(error);
    notification(i18n.t('notifications:content_library.file_download_error'));
  }
}
